/*
	GETTERS
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------
//------------------------------------------------------------
// GET ALL CHARACTERS
//------------------------------------------------------------

const getAllCharacters = (state) => {
	return state.characters;
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	getAllCharacters,
};